import { fromJS } from 'immutable';
import {
  ANALYZE_TYPOLOGIES,
  ANALYZE_TYPOLOGIES_SUCCESS,
  ANALYZE_TYPOLOGIES_FAILED,
  RESET_TYPOLOGY_ANALYSIS
} from '../../actions/trm/typologyAnalyzer';

const initialState = fromJS({
  isLoading: false,
  error: null,
  typologies: [],
  riskIndicators: null,
  explanationGraph: null,
  dataModelFields: [],
  typologyFieldMap: {},
  indicatorLogics: [],
  typologyStructure: null
});

export default function typologyAnalyzerReducer(state = initialState, action) {
  switch (action.type) {
    case ANALYZE_TYPOLOGIES:
      return state
        .set('isLoading', true)
        .set('error', null)
        .set('typologies', [])
        .set('riskIndicators', null)
        .set('explanationGraph', null)
        .set('dataModelFields', [])
        .set('typologyFieldMap', {})
        .set('indicatorLogics', [])
        .set('typologyStructure', null);

    case ANALYZE_TYPOLOGIES_SUCCESS:
      return state
        .set('isLoading', false)
        .set('typologies', action.payload.typologies || [])
        .set('riskIndicators', action.payload.riskIndicators || null)
        .set('explanationGraph', action.payload.explanationGraph || null)
        .set('dataModelFields', action.payload.dataModelFields || [])
        .set('typologyFieldMap', action.payload.typologyFieldMap || {})
        .set('indicatorLogics', action.payload.indicatorLogics || [])
        .set('typologyStructure', action.payload._typologyStructure || null);

    case ANALYZE_TYPOLOGIES_FAILED:
      return state
        .set('isLoading', false)
        .set('error', action.payload);

    case RESET_TYPOLOGY_ANALYSIS:
      return initialState;

    default:
      return state;
  }
}
